export const faqData = [
  {
    id: 'allgemein',
    headline: {
      de: 'Allgemeine Fragen',
      en: 'General Questions'
    },
    body: {
      de: [
        'In welchen Sprachen sind die E-Learnings verfügbar?',
        'Alle Module sind grundsätzlich in Deutsch und Englisch verfügbar.',
        'Zusätzliche Sprachen sind je nach Modul verfügbar und auf unserer Website ersichtlich.',
        'Sollte eine gewünschte Sprache nicht dabei sein, kann diese bei Bedarf umgesetzt werden.',
        'Sprechen Sie uns einfach an – wir finden eine passende Lösung.',
        'Können die Inhalte an unser Unternehmen angepasst werden?',
        'Ja.',
        'Unsere Module können an Ihr Corporate Design angepasst und um unternehmensspezifische Inhalte (z. B. interne Sicherheitsregeln oder Notfallpläne) ergänzt werden.',
        'Auch bestehende Inhalte oder Unterweisungen können übernommen und in die Module integriert werden.',
        'Auf Wunsch erweitern wir die Trainings um zusätzliche Kapitel oder spezifische Inhalte Ihres Unternehmens.',
        'So entsteht eine Lösung, die optimal zu Ihren bestehenden Prozessen passt.',
        'Wie lange dauert eine typische E-Learning-Einheit?',
        'Die Dauer variiert je nach Thema, liegt aber typischerweise zwischen 15 und 45 Minuten pro Modul.',
        'Die Inhalte sind so aufgebaut, dass sie kompakt und effizient absolviert werden können.',
        'Können Mitarbeiter die Unterweisungen zeit- und ortsunabhängig absolvieren?',
        'Ja.',
        'Die Unterweisungen können flexibel durchgeführt werden – unabhängig von Zeit und Ort.',
        'Das erleichtert die Organisation und reduziert Ausfallzeiten im Betrieb.',
        'Wie schnell können wir starten?',
        'In der Regel kann das System innerhalb weniger Wochen eingeführt werden.',
        'Standardmodule sind sofort verfügbar und können bei Bedarf angepasst werden.',
        'Können bestehende Inhalte übernommen werden?',
        'Ja.',
        'Bestehende Unterlagen oder Inhalte können übernommen und in digitale Form gebracht werden.',
        'So bleibt vorhandenes Wissen erhalten und wird strukturiert weiterverwendet.'
      ],
      en: [
        'In which languages are the e-learnings available?',
        'All modules are generally available in German and English.',
        'Additional languages are available depending on the module and can be found on our website.',
        'If a desired language is not available, it can be implemented upon request.',
        'Simply contact us – we will find a suitable solution.',
        'Can the content be customized for our company?',
        'Yes.',
        'Our modules can be adapted to your corporate design and supplemented with company-specific content (e.g., internal safety rules or emergency plans).',
        'Existing content or instructions can also be incorporated and integrated into the modules.',
        'Upon request, we can expand the training with additional chapters or specific content from your company.',
        'This creates a solution that optimally fits your existing processes.',
        'How long does a typical e-learning unit take?',
        'The duration varies depending on the topic, but typically ranges between 15 and 45 minutes per module.',
        'The content is designed to be completed compactly and efficiently.',
        'Can employees complete the training regardless of time and location?',
        'Yes.',
        'The training can be conducted flexibly – independent of time and place.',
        'This facilitates organization and reduces downtime in operations.',
        'How quickly can we get started?',
        'Typically, the system can be implemented within a few weeks.',
        'Standard modules are immediately available and can be customized as needed.',
        'Can existing content be adopted?',
        'Yes.',
        'Existing documents or content can be adopted and converted into digital form.',
        'This preserves existing knowledge and allows it to be reused in a structured manner.'
      ]
    }
  },
  {
    id: 'sfk',
    headline: {
      de: 'Für Sicherheitsfachkräfte',
      en: 'For Safety Officers'
    },
    body: {
      de: [
        'Macht E-Training meinen Job als Sicherheitsfachkraft überflüssig?',
        'Ganz im Gegenteil! Die Unterweisungsmodule ersetzen nicht die persönliche, arbeitsplatzbezogene Unterweisung nach § 14 ASchG. Vielmehr sind E-Trainings unterstützende Werkzeuge, um die Arbeitssicherheit nachhaltig zu erhöhen. Sie gewinnen wertvolle Zeit für Ihre Kernaufgaben.',
        'Kann eine Unterweisung am Computer einen Menschen ersetzen?',
        'Nein, und das soll sie auch nicht!',
        'E-Trainings vermitteln standardisierte Grundlagen und wiederkehrende Inhalte.',
        'Die persönliche Unterweisung bleibt weiterhin entscheidend – insbesondere für arbeitsplatzbezogene Risiken und praktische Einweisungen.',
        'Die Kombination aus E-Learning und persönlicher Unterweisung ist in der Praxis am effektivsten.',
        'Welche Unterweisungen werden durch E-Trainings abgedeckt?',
        'Unsere Lernmodule decken die Inhalte der Informationspflicht nach § 12 ASchG sowie die wiederkehrende Unterweisungspflicht nach § 14 ASchG für die jeweilige Zielgruppe ab. Die Module sind mit dem Zentral-Arbeitsinspektorat abgestimmt.',
        'Wie aufwendig ist die Umstellung und laufende Betreuung?',
        'Die Einführung ist in der Regel unkompliziert und strukturiert umsetzbar.',
        'Standardinhalte sind bereits aufbereitet – Sie müssen nicht alles neu erstellen.',
        'Ihre Rolle liegt weiterhin in der fachlichen Ergänzung und arbeitsplatzbezogenen Anpassung, nicht in der vollständigen Inhaltserstellung.',
        'Zusätzlich kümmern wir uns um die laufende Aktualisierung der Inhalte bei gesetzlichen Änderungen. Diese werden in Abstimmung mit Ihnen in die Unterweisungen integriert, sodass Sie dauerhaft auf dem aktuellen Stand bleiben.',
        'Dadurch reduzieren sich nicht nur der organisatorische Aufwand, sondern auch der laufende Pflegeaufwand im Vergleich zu klassischen Unterweisungen deutlich.',
        'Wie stelle ich sicher, dass Mitarbeiter die Inhalte wirklich verstehen?',
        'Durch integrierte Verständnistests wird überprüft, ob Inhalte verstanden wurden.',
        'Zusätzlich können Sie jederzeit:',
        'Ergebnisse einsehen',
        'gezielt nachschulen',
        'persönliche Unterweisungen darauf aufbauen'
      ],
      en: [
        'Does e-training make my job as a safety officer obsolete?',
        'Quite the opposite! The training modules do not replace personal, workplace-specific instruction according to § 14 ASchG. Rather, e-trainings are supporting tools to sustainably increase workplace safety. You gain valuable time for your core tasks.',
        'Can computer-based training replace a human instructor?',
        'No, and it is not meant to!',
        'E-trainings convey standardized basics and recurring content.',
        'Personal instruction remains crucial – especially for workplace-specific risks and practical training.',
        'The combination of e-learning and personal instruction is most effective in practice.',
        'What training topics are covered by e-trainings?',
        'Our learning modules cover the content of the information obligation according to § 12 ASchG as well as the recurring training obligation according to § 14 ASchG for the respective target group. The modules are coordinated with the Central Labour Inspectorate.',
        'How complex is the transition and ongoing support?',
        'Implementation is usually straightforward and can be done in a structured manner.',
        'Standard content is already prepared – you do not have to create everything from scratch.',
        'Your role remains in professional supplementation and workplace-specific adaptation, not in complete content creation.',
        'Additionally, we take care of ongoing content updates when legal changes occur. These are integrated into the training in coordination with you, so you always stay up to date.',
        'This significantly reduces not only the organizational effort but also the ongoing maintenance effort compared to traditional training.',
        'How do I ensure that employees really understand the content?',
        'Integrated comprehension tests verify whether content has been understood.',
        'Additionally, you can at any time:',
        'View results',
        'Provide targeted retraining',
        'Build personal instruction upon it'
      ]
    }
  },
  {
    id: 'gf',
    headline: {
      de: 'Für Geschäftsführer',
      en: 'For Executives'
    },
    body: {
      de: [
        'Warum brauche ich E-Trainings für Arbeitssicherheit?',
        'In Österreich passieren jährlich rund 100.000 Arbeitsunfälle.',
        'Als Geschäftsführer sind Sie verpflichtet, Ihre Mitarbeiter nachweislich zu unterweisen.',
        'Mit E-Trainings erfüllen Sie diese Pflicht strukturiert, dokumentiert und rechtssicher – und reduzieren gleichzeitig Ihr persönliches Haftungsrisiko.',
        'Wir haben bisher auch ohne E-Trainings gearbeitet – warum jetzt umstellen?',
        'Früher wurden Unterweisungen oft informell oder unregelmäßig durchgeführt.',
        'Heute zählt vor allem eines:',
        'Nachweisbarkeit und Dokumentation',
        'Im Ernstfall müssen Sie belegen können:',
        'dass unterwiesen wurde',
        'was vermittelt wurde',
        'und ob es verstanden wurde',
        'Genau das leisten E-Trainings.',
        'Was sind die Vorteile von E-Trainings?',
        '• Rechtssichere Dokumentation inkl. Verständnistest',
        '• Reduktion des Haftungsrisikos',
        '• Einheitliche Qualität der Unterweisungen',
        '• Zeitersparnis gegenüber Präsenzschulungen',
        '• Aktivierbar im Anlagevermögen',
        'E-Trainings reduzieren nicht nur den organisatorischen Aufwand, sondern senken langfristig auch die Kosten im Vergleich zu klassischen Präsenzunterweisungen – bei gleichzeitig höherer Rechtssicherheit.',
        'Wie wird mein Haftungsrisiko konkret reduziert?',
        'Jede Unterweisung wird lückenlos dokumentiert.',
        'Sie können jederzeit nachweisen:',
        'wer geschult wurde',
        'wann die Schulung erfolgt ist',
        'ob die Inhalte verstanden wurden',
        'Im Ernstfall ist das entscheidend gegenüber Behörden und Gerichten.',
        'Wie hoch sind die Kosten für E-Learning?',
        'Die Kosten richten sich nach dem individuellen Bedarf Ihres Unternehmens.',
        'Wichtig für Sie:',
        'deutlich geringerer Zeitaufwand',
        'keine wiederkehrenden Präsenzkosten',
        'Aktivierung im Anlagevermögen möglich',
        'Wie aufwendig ist die Einführung im Unternehmen?',
        'Die Einführung ist in der Regel unkompliziert und innerhalb weniger Wochen umsetzbar.',
        'Inhalte können standardisiert übernommen oder individuell angepasst werden.',
        'Ihre Mitarbeiter können die Unterweisungen zeit- und ortsunabhängig absolvieren.'
      ],
      en: [
        'Why do I need e-training for workplace safety?',
        'In Austria, approximately 100,000 workplace accidents occur annually.',
        'As an executive, you are obligated to demonstrably train your employees.',
        'With e-training, you fulfill this obligation in a structured, documented, and legally secure manner – while simultaneously reducing your personal liability risk.',
        'We have worked without e-training until now – why switch now?',
        'In the past, training was often conducted informally or irregularly.',
        'Today, one thing matters above all:',
        'Verifiability and documentation',
        'In case of an emergency, you must be able to prove:',
        'that training was conducted',
        'what was conveyed',
        'and whether it was understood',
        'This is exactly what e-training provides.',
        'What are the advantages of e-training?',
        '• Legally secure documentation including comprehension test',
        '• Reduction of liability risk',
        '• Consistent quality of training',
        '• Time savings compared to in-person training',
        '• Can be capitalized as fixed assets',
        'E-training not only reduces organizational effort but also lowers costs in the long term compared to traditional in-person training – while providing greater legal certainty.',
        'How is my liability risk specifically reduced?',
        'Every training session is fully documented.',
        'You can prove at any time:',
        'who was trained',
        'when the training took place',
        'whether the content was understood',
        'In an emergency, this is crucial for authorities and courts.',
        'How much does e-learning cost?',
        'Costs depend on your company\'s individual needs.',
        'Important for you:',
        'significantly less time required',
        'no recurring in-person training costs',
        'capitalization as fixed assets possible',
        'How complex is the implementation in the company?',
        'Implementation is usually straightforward and can be done within a few weeks.',
        'Content can be adopted as standard or individually customized.',
        'Your employees can complete the training regardless of time and location.'
      ]
    }
  },
  {
    id: 'hr',
    headline: {
      de: 'Für HR & Personal',
      en: 'For HR & Personnel'
    },
    body: {
      de: [
        'Wie kann HR von E-Learning profitieren?',
        'E-Learning ermöglicht eine effiziente Organisation von Pflichtschulungen.',
        'automatische Zuweisung von Unterweisungen',
        'klare Übersicht über den Status aller Mitarbeiter',
        'einfaches Onboarding mit standardisierten Inhalten',
        'Sie sparen Zeit, reduzieren administrativen Aufwand und profitieren von einer klar planbaren Kostenstruktur.',
        'Wie werden die Unterweisungen dokumentiert?',
        'Jede absolvierte Schulung wird automatisch im System dokumentiert.',
        'Sie erhalten:',
        'Teilnahmeübersichten',
        'Testergebnisse',
        'Zertifikate',
        'Alle Daten sind revisionssicher gespeichert und jederzeit abrufbar.',
        'Wie aufwendig ist die Verwaltung im Alltag?',
        'Die Verwaltung ist bewusst einfach und übersichtlich aufgebaut.',
        'klare Benutzerführung',
        'keine komplexen Systeme notwendig',
        'Fokus auf das Wesentliche',
        'Ziel ist es, den administrativen Aufwand für HR so gering wie möglich zu halten.',
        'Wie wird sichergestellt, dass Mitarbeiter die Inhalte verstehen?',
        'Durch integrierte Verständnistests wird überprüft, ob Inhalte verstanden wurden.',
        'Sie sehen auf einen Blick:',
        'wer geschult wurde',
        'wer bestanden hat',
        'wo Nachholbedarf besteht',
        'Ist das System auch für Mitarbeiter einfach nutzbar?',
        'Ja.',
        'Die Bedienung ist so aufgebaut, dass sie ohne Schulung verständlich ist.',
        'Wer ein Smartphone bedienen kann, kommt auch mit dem System problemlos zurecht.',
        'Einheitlicher Aufbau sorgt für schnelle Orientierung und hohe Akzeptanz.'
      ],
      en: [
        'How can HR benefit from e-learning?',
        'E-learning enables efficient organization of mandatory training.',
        'automatic assignment of training',
        'clear overview of all employees\' status',
        'easy onboarding with standardized content',
        'You save time, reduce administrative effort, and benefit from a clearly plannable cost structure.',
        'How is the training documented?',
        'Every completed training is automatically documented in the system.',
        'You receive:',
        'Participation overviews',
        'Test results',
        'Certificates',
        'All data is stored in an audit-proof manner and can be accessed at any time.',
        'How complex is the daily administration?',
        'Administration is deliberately simple and clear.',
        'clear user guidance',
        'no complex systems necessary',
        'focus on the essentials',
        'The goal is to keep administrative effort for HR as low as possible.',
        'How is it ensured that employees understand the content?',
        'Integrated comprehension tests verify whether content has been understood.',
        'You can see at a glance:',
        'who was trained',
        'who passed',
        'where there is a need for follow-up',
        'Is the system also easy to use for employees?',
        'Yes.',
        'The interface is designed to be understandable without training.',
        'Anyone who can operate a smartphone can easily use the system.',
        'Consistent structure ensures quick orientation and high acceptance.'
      ]
    }
  },
  {
    id: 'it',
    headline: {
      de: 'Für IT-Mitarbeiter',
      en: 'For IT Staff'
    },
    body: {
      de: [
        'Wie aufwendig ist die Einführung des Systems?',
        'Die Einführung ist in der Regel unkompliziert und schnell umsetzbar.',
        'Das Unterweisungssystem läuft als eigenständige Lösung und kann entweder gehostet (DSGVO-konform) oder On-Premise betrieben werden.',
        'Der technische Aufwand bleibt dabei überschaubar.',
        'Müssen bestehende Systeme angebunden werden?',
        'Nein.',
        'Das System funktioniert vollständig eigenständig und kann auch ohne Schnittstellen betrieben werden.',
        'Schnittstellen werden nur dann umgesetzt, wenn sie tatsächlich benötigt werden.',
        'Können bestehende Systeme angebunden werden?',
        'Ja, bei Bedarf.',
        'Typische Anwendungsfälle:',
        'Übernahme von Personaldaten (z. B. SAP, BMD)',
        'Rückmeldung von Schulungsstatus und Ergebnissen',
        'Ziel ist es, Doppelpflege zu vermeiden.',
        'Wo wird das System betrieben?',
        'Das System kann wahlweise:',
        'gehostet (DSGVO-konform in Europa/Österreich)',
        'oder On-Premise im eigenen Unternehmen',
        'betrieben werden.',
        'Wie erfolgt die technische Abstimmung?',
        'Die Details werden direkt zwischen den IT-Abteilungen abgestimmt.',
        'Der Fokus liegt auf einer einfachen und sauberen Umsetzung, ohne unnötige Komplexität.'
      ],
      en: [
        'How complex is the system implementation?',
        'Implementation is usually straightforward and quick.',
        'The training system runs as a standalone solution and can be either hosted (GDPR-compliant) or operated on-premise.',
        'The technical effort remains manageable.',
        'Do existing systems need to be connected?',
        'No.',
        'The system works completely independently and can also be operated without interfaces.',
        'Interfaces are only implemented when they are actually needed.',
        'Can existing systems be connected?',
        'Yes, if needed.',
        'Typical use cases:',
        'Import of personnel data (e.g., SAP, BMD)',
        'Feedback of training status and results',
        'The goal is to avoid duplicate data maintenance.',
        'Where is the system operated?',
        'The system can optionally be:',
        'hosted (GDPR-compliant in Europe/Austria)',
        'or on-premise in your own company',
        'operated.',
        'How is the technical coordination done?',
        'Details are coordinated directly between IT departments.',
        'The focus is on simple and clean implementation, without unnecessary complexity.'
      ]
    }
  },
  {
    id: 'systemvoraussetzungen',
    headline: {
      de: 'Systemvoraussetzungen',
      en: 'System Requirements'
    },
    body: {
      de: [
        'Welche technischen Voraussetzungen brauche ich?',
        'Für die Nutzung des Unterweisungssystems benötigen Sie:',
        'Internetverbindung',
        'aktuellen Webbrowser',
        'aktiviertes JavaScript',
        'Das System ist webbasiert und kann ohne zusätzliche Installation genutzt werden.',
        'Welche Geräte und Browser werden unterstützt?',
        'Die Nutzung ist auf allen gängigen Geräten möglich:',
        'Desktop-PC',
        'Laptop',
        'Tablet',
        'Smartphone',
        'Unterstützt werden alle aktuellen Browser, wie z. B.:',
        'Google Chrome',
        'Microsoft Edge',
        'Mozilla Firefox',
        'Safari',
        'Welche Standards werden für e-Trainings unterstützt?',
        'Unsere e-Trainings unterstützen:',
        'SCORM 1.2',
        'SCORM 2004',
        'xAPI (TinCan)',
        'Damit können Inhalte auch in bestehende Lernmanagementsysteme integriert werden.',
        'Was ist, wenn wir kein Lernmanagementsystem (LMS) haben?',
        'Kein Problem.',
        'Unser Unterweisungssystem funktioniert eigenständig und ohne zusätzliches LMS.',
        'Alternativ können e-Trainings bei Bedarf auch:',
        'webbasiert',
        'oder offline (eingeschränkte Funktionalität)',
        'bereitgestellt werden.'
      ],
      en: [
        'What technical requirements do I need?',
        'To use the training system, you need:',
        'Internet connection',
        'current web browser',
        'JavaScript enabled',
        'The system is web-based and can be used without additional installation.',
        'What devices and browsers are supported?',
        'Usage is possible on all common devices:',
        'Desktop PC',
        'Laptop',
        'Tablet',
        'Smartphone',
        'All current browsers are supported, such as:',
        'Google Chrome',
        'Microsoft Edge',
        'Mozilla Firefox',
        'Safari',
        'What standards are supported for e-trainings?',
        'Our e-trainings support:',
        'SCORM 1.2',
        'SCORM 2004',
        'xAPI (TinCan)',
        'This allows content to be integrated into existing learning management systems.',
        'What if we don\'t have a learning management system (LMS)?',
        'No problem.',
        'Our training system works independently without an additional LMS.',
        'Alternatively, e-trainings can also be provided:',
        'web-based',
        'or offline (limited functionality)',
        'as needed.'
      ]
    }
  },
  {
    id: 'fit4',
    headline: {
      de: 'Fit4 e-Trainings',
      en: 'Fit4 e-Trainings'
    },
    body: {
      de: [
        'Wie werden die Fit4 e-Trainings bereitgestellt?',
        'Die Bereitstellung erfolgt je nach Situation:',
        'Nutzung über unser Unterweisungssystem ematrixsys',
        'oder Integration in ein bestehendes System (z. B. als SCORM)',
        'Das System ist sofort einsatzbereit – ohne technische Vorbereitung.',
        'Wie aufwendig ist der Start (Onboarding)?',
        'Der Start ist bewusst einfach und schnell.',
        'Für die Einrichtung benötigen wir lediglich eine Liste der Mitarbeiter (z. B. Excel mit Name, Abteilung und E-Mail).',
        'Das System wird von uns vorbereitet – Sie können unmittelbar starten.',
        'Kein komplexes Setup, kein IT-Projekt.',
        'Können neue Mitarbeiter laufend hinzugefügt werden?',
        'Ja.',
        'Neue Mitarbeiter können jederzeit hinzugefügt und geschult werden.',
        'Das System ist auf eine laufende Nutzung ausgelegt und unterstützt auch regelmäßige Neueintritte.',
        'Wie behalten wir den Überblick über die Schulungen?',
        'Im System sehen Sie jederzeit:',
        'wer geschult wurde',
        'wer noch offen ist',
        'Testergebnisse und Zertifikate',
        'Zusätzlich erhalten Sie automatische Erinnerungen und Auswertungen.',
        'Alle Daten stehen jederzeit für interne Kontrollen oder Audits zur Verfügung.',
        'Erhalten die Mitarbeiter ein Zertifikat?',
        'Ja.',
        'Nach erfolgreicher Absolvierung erhalten die Mitarbeiter ein Zertifikat als Nachweis.',
        'Ist die Verwaltungsplattform im Preis enthalten?',
        'Ja.',
        'Die Nutzung des Unterweisungssystems inklusive Verwaltung, Monitoring und Dokumentation ist Bestandteil der Lösung.',
        'Können Inhalte erweitert oder ergänzt werden?',
        'Ja.',
        'Bestehende Module können bei Bedarf erweitert oder ergänzt werden.',
        'Auch zusätzliche Schulungen können jederzeit integriert werden.',
        'Sind die Fit4 e-Trainings für Audits und Standards geeignet?',
        'Ja.',
        'Die Inhalte unterstützen Anforderungen aus gängigen Standards wie ISO 27001, ISO 45001 oder TISAX® und helfen dabei, Schulungen nachvollziehbar und prüfbar zu dokumentieren.'
      ],
      en: [
        'How are Fit4 e-trainings provided?',
        'Delivery depends on the situation:',
        'Use via our training system ematrixsys',
        'or integration into an existing system (e.g., as SCORM)',
        'The system is ready to use immediately – without technical preparation.',
        'How complex is getting started (onboarding)?',
        'Getting started is deliberately simple and fast.',
        'For setup, we only need a list of employees (e.g., Excel with name, department, and email).',
        'The system is prepared by us – you can start immediately.',
        'No complex setup, no IT project.',
        'Can new employees be added continuously?',
        'Yes.',
        'New employees can be added and trained at any time.',
        'The system is designed for ongoing use and also supports regular new hires.',
        'How do we keep track of the training?',
        'In the system, you can see at any time:',
        'who was trained',
        'who is still pending',
        'Test results and certificates',
        'Additionally, you receive automatic reminders and evaluations.',
        'All data is available at any time for internal controls or audits.',
        'Do employees receive a certificate?',
        'Yes.',
        'After successful completion, employees receive a certificate as proof.',
        'Is the administration platform included in the price?',
        'Yes.',
        'The use of the training system including administration, monitoring, and documentation is part of the solution.',
        'Can content be expanded or supplemented?',
        'Yes.',
        'Existing modules can be expanded or supplemented as needed.',
        'Additional training can also be integrated at any time.',
        'Are Fit4 e-trainings suitable for audits and standards?',
        'Yes.',
        'The content supports requirements from common standards such as ISO 27001, ISO 45001, or TISAX® and helps to document training in a traceable and auditable manner.'
      ]
    }
  },
  {
    id: 'besucherunterweisungssystem',
    headline: {
      de: 'Besucherunterweisungssystem',
      en: 'Visitor Training System'
    },
    body: {
      de: [
        'Was ist das Besucherunterweisungssystem?',
        'Das Besucherunterweisungssystem ist eine zentrale Plattform zur Verwaltung, Zuweisung und Dokumentation von Unterweisungen für:',
        'Besucher',
        'Fremdfirmen',
        'Kontraktoren',
        'Fahrer / Spediteure',
        'Das System stellt sicher, dass jede Person die richtige Unterweisung zur richtigen Zeit erhält und diese nachweisbar dokumentiert wird.',
        'Wie unterscheidet sich das System von einfachen „Unterschriftenlösungen"?',
        'In vielen Unternehmen werden Unterweisungen über Unterschriften (Papier oder Tablet) dokumentiert.',
        'Dabei bleibt jedoch oft unklar:',
        'welche Inhalte tatsächlich vermittelt wurden',
        'ob diese verstanden wurden',
        'Unser Ansatz basiert auf strukturierten e-Trainings mit integrierten Verständnistests.',
        'So wird sichergestellt, dass Inhalte nicht nur bestätigt, sondern nachweislich verstanden werden.',
        'Können Unterweisungen direkt im System erstellt werden?',
        'Das System ist darauf ausgelegt, Unterweisungen effizient zu verwalten, zuzuweisen und zu dokumentieren.',
        'Die Inhalte selbst werden in der Regel als e-Learning-Module erstellt und in das System eingebunden.',
        'Dabei können sowohl bestehende Inhalte verwendet als auch neue Module erstellt werden.',
        'Können wir eigene e-Trainings verwenden?',
        'Ja, sofern diese gängigen Industriestandards entsprechen (z. B. SCORM).',
        'Bestehende e-Trainings können so problemlos integriert werden.',
        'Alternativ unterstützen wir Sie auch bei der Erstellung individueller Inhalte.',
        'Wie wird gesteuert, wer welche Unterweisung erhält?',
        'Die Zuweisung erfolgt über eine Zuweisungslogik bzw. Matrix.',
        'Dabei können z. B. berücksichtigt werden:',
        'Standort',
        'Tätigkeit',
        'Firma / Rolle',
        'spezifische Anforderungen',
        'Auch mehrere Standorte und unterschiedliche Anforderungen können zentral und strukturiert abgebildet werden.',
        'Können Unterweisungen mit anderen Systemen verknüpft werden?',
        'Ja.',
        'Bei Bedarf kann das System mit bestehenden Lösungen (z. B. Zutritts- oder Schließsystemen) verbunden werden.',
        'So kann gesteuert werden, dass eine Person nur dann Zutritt erhält, wenn die erforderliche Unterweisung erfolgreich absolviert wurde.',
        'Wie erfolgt die Dokumentation der Unterweisungen?',
        'Alle Unterweisungen werden automatisch dokumentiert.',
        'Es ist jederzeit nachvollziehbar:',
        'wer geschult wurde',
        'wann die Schulung erfolgt ist',
        'ob die Inhalte erfolgreich absolviert wurden',
        'Die Daten stehen für Audits und Kontrollen zur Verfügung.',
        'Können Unterweisungen vorab durchgeführt werden?',
        'Ja.',
        'Unterweisungen können bereits vor dem Besuch oder Einsatz durchgeführt werden.',
        'Das reduziert Wartezeiten vor Ort und sorgt für einen reibungslosen Ablauf beim Zutritt.'
      ],
      en: [
        'What is the visitor training system?',
        'The visitor training system is a central platform for managing, assigning, and documenting training for:',
        'Visitors',
        'External companies',
        'Contractors',
        'Drivers / Freight forwarders',
        'The system ensures that each person receives the right training at the right time and that this is documented in a verifiable manner.',
        'How does the system differ from simple "signature solutions"?',
        'In many companies, training is documented via signatures (paper or tablet).',
        'However, it often remains unclear:',
        'what content was actually conveyed',
        'whether it was understood',
        'Our approach is based on structured e-trainings with integrated comprehension tests.',
        'This ensures that content is not only confirmed but demonstrably understood.',
        'Can training be created directly in the system?',
        'The system is designed to efficiently manage, assign, and document training.',
        'The content itself is usually created as e-learning modules and integrated into the system.',
        'Both existing content can be used and new modules can be created.',
        'Can we use our own e-trainings?',
        'Yes, as long as they comply with common industry standards (e.g., SCORM).',
        'Existing e-trainings can thus be easily integrated.',
        'Alternatively, we also support you in creating individual content.',
        'How is it controlled who receives which training?',
        'Assignment is done via an assignment logic or matrix.',
        'For example, the following can be considered:',
        'Location',
        'Activity',
        'Company / Role',
        'specific requirements',
        'Multiple locations and different requirements can also be mapped centrally and in a structured manner.',
        'Can training be linked to other systems?',
        'Yes.',
        'If needed, the system can be connected to existing solutions (e.g., access or locking systems).',
        'This can control that a person only gains access when the required training has been successfully completed.',
        'How is the training documented?',
        'All training is automatically documented.',
        'It is traceable at any time:',
        'who was trained',
        'when the training took place',
        'whether the content was successfully completed',
        'The data is available for audits and controls.',
        'Can training be conducted in advance?',
        'Yes.',
        'Training can be conducted before the visit or assignment.',
        'This reduces waiting times on site and ensures a smooth process upon entry.'
      ]
    }
  },
  {
    id: 'individuelle_etrainings',
    headline: {
      de: 'Individuelle e-Trainings',
      en: 'Custom e-Trainings'
    },
    body: {
      de: [
        'Können individuelle e-Trainings erstellt werden?',
        'Ja.',
        'Neben unseren Standardmodulen entwickeln wir auch individuelle e-Trainings, die exakt auf Ihr Unternehmen abgestimmt sind.',
        'Wie läuft die Erstellung eines individuellen e-Trainings ab?',
        'Die Umsetzung erfolgt strukturiert:',
        'Abstimmung der Inhalte und Ziele',
        'Aufbereitung der bestehenden Unterlagen',
        'Erstellung des e-Trainings',
        'Abstimmung und Freigabe',
        'Sie liefern die Inhalte – wir übernehmen die didaktische und technische Umsetzung.',
        'Können bestehende Unterlagen verwendet werden?',
        'Ja.',
        'Vorhandene Präsentationen, Dokumente oder Unterweisungen können übernommen und in ein e-Training überführt werden.',
        'Wie aufwendig ist die Erstellung für uns intern?',
        'Der Aufwand für Ihr Unternehmen bleibt überschaubar.',
        'Sie liefern die fachlichen Inhalte – wir kümmern uns um:',
        'Struktur',
        'Gestaltung',
        'Umsetzung',
        'Können bestehende e-Trainings erweitert werden?',
        'Ja.',
        'Bestehende Module können jederzeit angepasst, erweitert oder ergänzt werden.'
      ],
      en: [
        'Can custom e-trainings be created?',
        'Yes.',
        'In addition to our standard modules, we also develop custom e-trainings that are precisely tailored to your company.',
        'How does the creation of a custom e-training work?',
        'Implementation is structured:',
        'Coordination of content and goals',
        'Preparation of existing documents',
        'Creation of the e-training',
        'Coordination and approval',
        'You provide the content – we handle the didactic and technical implementation.',
        'Can existing documents be used?',
        'Yes.',
        'Existing presentations, documents, or training materials can be adopted and converted into an e-training.',
        'How complex is the creation for us internally?',
        'The effort for your company remains manageable.',
        'You provide the professional content – we take care of:',
        'Structure',
        'Design',
        'Implementation',
        'Can existing e-trainings be expanded?',
        'Yes.',
        'Existing modules can be adapted, expanded, or supplemented at any time.'
      ]
    }
  }
];
